import { readStaffTenantSlug, subscribeStaffTenantChange } from "@l30/shared";
import { useEffect, useState } from "react";

/** Cache-key segment so tenant-scoped queries cannot share rows across firms. */
export function staffTenantCacheScope(): string {
  return readStaffTenantSlug() ?? "host-default";
}

export function useStaffTenantScope(): string {
  const [scope, setScope] = useState(staffTenantCacheScope);
  useEffect(() => subscribeStaffTenantChange(() => setScope(staffTenantCacheScope())), []);
  return scope;
}
